import { FC, useEffect, useState } from 'react';
import { Input, InputGroup } from 'reactstrap';
import { useParsedSearchParams } from '../../../lib/util';
import bgImage from '../../../lib/images/header-search.webp';
import { useMsal } from '@azure/msal-react';
import classes from './FlocSearch.module.scss';
import { Alert, Button } from '@bphxd/ds-core-react';
import { useQuery } from '@apollo/client';
import { GET_FLOC_DETAILS } from '../../../graph-queries/materials/floc';
import { Search24 } from '@bphxd/ds-core-react/lib/icons';

interface FlocSearchProps {
  floc: string;
  setFloc: (value: string) => void;
}

const FlocSearch: FC<FlocSearchProps> = ({ floc, setFloc }) => {
  const [asset] = useParsedSearchParams('asset');
  const [inputFloc, setInputFloc] = useState(floc);
  const { accounts } = useMsal();
  const [error, setError] = useState('');

  const {
    data,
    loading,
    error: flocLoadError,
  } = useQuery(GET_FLOC_DETAILS, {
    variables: { asset, floc },
    skip: !floc,
  });

  const searchFloc = () => {
    setFloc(inputFloc.toUpperCase());
  };

  useEffect(() => {
    if (flocLoadError) {
      setError(`Failed to fetch Functional Location ID: ${inputFloc}`);
    } else if (data && !loading) {
      if (data?.flocDetails.flocExists) {
        setError('');
      } else {
        setError(`Invalid Functional Location ID: ${inputFloc}`);
      }
    }
  }, [data, loading, flocLoadError]);

  useEffect(() => {
    setInputFloc(floc);
  }, [floc]);

  useEffect(() => {
    setError('');
  }, [inputFloc]);

  const name = accounts?.[0]?.name || '';
  const firstName = (name.split(',').map((part) => part.trim())[1] || '').split(' ')[0] || '';
  const hours = new Date().getHours();
  const salutation = `Good ${hours < 12 ? 'morning' : hours > 17 ? 'evening' : 'afternoon'}, `;

  return (
    <section
      className="pb-12 pt-10 gap-6 text-center"
      style={{ backgroundImage: `url(${bgImage})`, backgroundSize: 'cover' }}
    >
      {!floc && (
        <div className={classes.title}>
          {salutation}
          {firstName}
        </div>
      )}
      <InputGroup className="w-50 d-inline-flex gap-5">
        <Input
          value={inputFloc}
          onChange={(e) => setInputFloc(e.target.value)}
          placeholder="Enter FLOC including prefix i.e. 'GM10-' etc."
          className="bg-primary"
        />
        <Button
          color="darker-outline"
          onClick={searchFloc}
          disabled={loading}
          className="bg-primary"
          Icon={Search24}
        >
          {loading ? 'Searching' : 'Search'}
        </Button>

        {error && (
          <Alert
            className="w-100 d-inline-block position-absolute"
            color="danger"
            style={{ top: 48 }}
          >
            {error}
          </Alert>
        )}
      </InputGroup>
    </section>
  );
};

export default FlocSearch;
